import React, {useState} from "react";
import s from './Create.module.css';
import {FormControl, InputLabel, MenuItem, Select, TextField} from '@material-ui/core';
import {Editor} from "@tinymce/tinymce-react";
import {_axios} from "../../../axios/_axios";

const initialPage = {
  desc: '',
  title: '',
  fName: "",
  sName: '',
  scienceLevel: '',
  scienceTitle: '',
}

const Create = () => {
  const token = localStorage.getItem('_token');
  const [page, setPage] = useState(initialPage);
  const [tab, setTab] = useState('');

  const handleEditorChange = (content) => {
    setPage({...page, desc: content})
  }
  const handleTitle = ({target}) => {
    setPage({...page, title: target.value})
  }
  const handleName = ({target}) => {
    setPage({...page, sName: target.value.split(' ')[0], fName: target.value.split(" ")[1]})
  }
  const handleShortDesc = ({target}) => {
    setPage({...page, short_desc: target.value})
  }
  const handleScienceLevel = ({target}) => {
    setPage({...page, scienceLevel: target.value})
  }
  const handleScienceTitle = ({target}) => {
    setPage({...page, scienceTitle: target.value})
  }

  const handleSubmit = () => {
    console.log('handleSubmit ===', tab)
    if ((page.title && page.desc) || (page.fName && page.sName)) {
      _axios.post(tab, page, {headers: {authorization: 'bear ' + token}})
        .then(({data}) => {
          console.log(data)
          handleGallerySend(data._id)
        })
        .catch(e => {
          console.log(e);
          alert("Сталася помилка")
        })
    } else {
      alert("Заповніть всі поля")
    }
  }

  const handleChangeTab = (e) => {
    setPage(initialPage)
    setTab(e.target.value)
  }

  const handleImageUpload = (blobInfo, success, failure, progress) => {
    const baseImage = blobInfo.base64();
    success('data:image/png;base64, ' + baseImage)
  }
  const handleUpload = ({target: {files}}) => {
    setPage({...page, gallery: files[0]})
  }

  const handleGallerySend = (id) => {
    const formData = new FormData();
    formData.append('gallery', page.gallery)
    _axios.post('people/' + id + '/upload', formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        authorization: 'bear ' + token
      }
    }).then(res => {
      res.status == 200 && alert('Створення успішне')
    })
      .catch(err => alert('Помилка при загрузці Фото'))
  }

  return (
    <div>
      <h2 className={s.title}> Створення </h2>
      <div className={s.table_list}>
        <FormControl variant="outlined" fullWidth>
          <InputLabel>Виберіть, що створювати</InputLabel>
          <Select
            error={!tab}
            value={tab ?? ''}
            onChange={handleChangeTab}
            label="Виберіть, що створювати"
          >
            <MenuItem value={'news'}>Новини</MenuItem>
            <MenuItem value={'science_activity'}>Навчальна діяльність</MenuItem>
            <MenuItem value={'people'}>Викладачі</MenuItem>
            <MenuItem value={'reviews'}>Відгуки</MenuItem>
            <MenuItem value={'blog'}>Блог</MenuItem>
          </Select>
        </FormControl>
      </div>
      {tab && <div className={s.container}>
        {tab === 'people' ?
          <TextField
            label={'Прізвище Імя'}
            variant="outlined"
            size={'small'}
            type={'search'}
            fullWidth
            // error={!page.sName}
            // value={page.sName + ' ' + page.fName}
            onChange={handleName}/>
          : <TextField
            label={'Заголовок'}
            variant="outlined"
            size={'small'}
            type={'search'}
            fullWidth
            error={!page.title}
            value={page.title}
            onChange={handleTitle}
          />}
        {(tab === 'news' || tab === 'science_activity') &&
        <div className={s.short_desc}>
          <TextField
            label={'Короткий опис'}
            variant="outlined"
            size={'small'}
            type={'search'}
            fullWidth
            error={!page.short_desc}
            value={page.short_desc}
            onChange={handleShortDesc}
          />
        </div>}
        {tab === 'people' &&
        <div className={s.short_desc}>
          <TextField
            label={'Вчене звання'}
            variant="outlined"
            size={'small'}
            type={'search'}
            fullWidth
            error={!page.scienceLevel}
            value={page.scienceLevel}
            onChange={handleScienceLevel}
          />
        </div>}
        {tab === 'people' &&
        <div className={s.short_desc}>
          <TextField
            label={'Науковий ступінь'}
            variant="outlined"
            size={'small'}
            type={'search'}
            fullWidth
            error={!page.scienceTitle}
            value={page.scienceTitle}
            onChange={handleScienceTitle}
          />
        </div>}
        {tab === 'people' &&
        <div className={s.short_desc}>
          <input
            accept={"image/png, image/jpeg"}
            placeholder={"Фото Викладача"}
            onChange={handleUpload}
            type={'file'}/>
        </div>}
        <h3>Опис</h3>
        <Editor
          initialValue={page.desc}
          value={page.desc}
          apiKey='42g6dqq1pkropr8mmiygujgq2ij57udq8rb8im2rmwti3ysm'
          init={{
            height: 500,
            menubar: false,
            plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount'
            ],
            toolbar: 'undo redo | image | formatselect | bold italic backcolor | \
              alignleft aligncenter alignright alignjustify | \
              bullist numlist outdent indent | removeformat | help',
            images_upload_handler: handleImageUpload
          }}
          onEditorChange={handleEditorChange}
        />
      </div>}
      <button className={s.btn} onClick={handleSubmit}>Створити</button>
    </div>
  );
};

export default Create;
